import clsx from 'clsx';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateStressAssessment } from '~/features/CreateStressAssessment';
import styles from './styles.module.scss';

export const Screen: React.FC = () => (
  <div
    className={clsx(styles.Screen, {
      [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
    })}
  >
    {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
    <CreateStressAssessment />
  </div>
);
